import { action } from 'satcheljs';

/**
 * Interface for the action message dispatched when onReadItem Switch is done.
 */
export interface onReadItemSwitchActionMessage {
    hostItemIndex: string;
    targetWindow: Window;
}

/**
 * Action to be dispatched when onReadItemSwitch is done.
 */
const onReadItemSwitch: (
    hostItemIndex: string,
    targetWindow: Window
) => onReadItemSwitchActionMessage = action(
    'onReadItemSwitch',
    (hostItemIndex, targetWindow): onReadItemSwitchActionMessage => ({
        hostItemIndex,
        targetWindow,
    })
);
export default onReadItemSwitch;
